import styled, { css } from 'styled-components';
import { isDefaultTheme } from '../../../utils/theming.js';
import { Tag } from '../../Tag/style.js';
import mq from '../../../utils/mediaQueries.js';

// @ts-nocheck
var PriceSummary = styled.div.withConfig({
  displayName: "PriceSummarystyle__PriceSummary",
  componentId: "sc-1u0b5nv-0"
})(["display:flex;flex-direction:column;", " ", " ", "{width:fit-content;margin-bottom:var(--space-100);}"], isDefaultTheme(css(["align-items:center;", " ", ""], function (_ref) {
  var $variant = _ref.$variant,
    $isPortraitCard = _ref.$isPortraitCard;
  return $variant === 'hotel' && !$isPortraitCard && css(["", ""], mq.m(css(["width:100%;"])));
}, function (_ref2) {
  var $isPortraitCard = _ref2.$isPortraitCard;
  return css(["", " ", ""], $isPortraitCard && css(["align-items:flex-end;"]), mq.mMax(css(["align-items:flex-end;"])));
})), function (_ref3) {
  var $noPriceInfo = _ref3.$noPriceInfo;
  return $noPriceInfo && css(["display:none;"]);
}, Tag);
var GrayPriceText = styled.div.withConfig({
  displayName: "PriceSummarystyle__GrayPriceText",
  componentId: "sc-1u0b5nv-1"
})(["color:var(--color-text-subtle);font-size:1.4rem;"]);
var OriginalPrice = styled(GrayPriceText).withConfig({
  displayName: "PriceSummarystyle__OriginalPrice",
  componentId: "sc-1u0b5nv-2"
})(["text-decoration:line-through;"]);
var Price = styled.div.withConfig({
  displayName: "PriceSummarystyle__Price",
  componentId: "sc-1u0b5nv-3"
})(["font:var(--font-headline-s);line-height:1;text-wrap:nowrap;", ""], isDefaultTheme(css(["font-size:2.4rem;", " ", ""], mq.s(css(["font-size:2.8rem;"])), function (_ref4) {
  var $hasDiscount = _ref4.$hasDiscount;
  return $hasDiscount && css(["color:var(--color-rouge-500);"]);
})));

export { GrayPriceText, OriginalPrice, Price, PriceSummary };
//# sourceMappingURL=PriceSummary.style.js.map
